import {useMemo, useState} from 'react'
import {useIntl} from 'react-intl'
import {Flex, Modal, Typography} from 'antd'
import InputText from '../../common/InputText'
import EllipsisTooltip from '../../common/EllipsisTooltip'
import {ProgresSpinner} from '../../common/ProgresSpinner'
import PromotedFilesPreview from '../preview'

const { Text } = Typography

const PromotedFilesModal = ({
  vehicle,
  detail,
  loading,
  vehicles = [],
  onSelectVehicle = () => {},
  onClose = () => {},
}) => {
  const intl = useIntl()
  const [listSearch, setListSearch] = useState('')

  const filteredVehicles = useMemo(() => {
    if (!listSearch) return vehicles
    const term = listSearch.toLowerCase()
    return vehicles.filter((item) =>
      `${item?.name || ''} ${item?.make_model_id || ''}`
        .toLowerCase()
        .includes(term)
    )
  }, [vehicles, listSearch])

  return (
    <Modal
      title={vehicle?.name || ''}
      open
      centered
      maskClosable={false}
      onCancel={onClose}
      width="90%"
      footer={null}
      className="promote-changes-preview-modal"
      destroyOnHidden
    >
      <Flex className="promote-preview-content">
        <Flex vertical className="preview-vehicle-list">
          <InputText
            name="preview_vehicle_search"
            placeholder={intl.formatMessage({
              id: 'promoteChanges.searchMakeModel',
            })}
            type="search"
            value={listSearch}
            isRequired={false}
            fieldless
            onChange={(value) => setListSearch(value)}
            wrapperClass="preview-vehicle-search"
          />
          <Flex vertical className="preview-vehicle-items">
            {filteredVehicles.map((item) => {
              const isActive = item?.vehicle_id === vehicle?.vehicle_id
              return (
                <div
                  key={`preview-vehicle-${item?.vehicle_id}`}
                  className={`preview-vehicle-item ${isActive ? 'active' : ''}`}
                  onClick={() => onSelectVehicle(item)}
                >
                  <EllipsisTooltip className="ellipsis">
                    {item?.name} ({item?.make_model_id})
                  </EllipsisTooltip>
                </div>
              )
            })}
            {filteredVehicles.length === 0 && (
              <Flex
                align="center"
                justify="center"
                className="promote-empty-state"
              >
                <Text type="secondary">
                  {intl.formatMessage({ id: 'promoteChanges.noRecords' })}
                </Text>
              </Flex>
            )}
          </Flex>
        </Flex>

        <Flex className="preview-detail-pane">
          {loading ? (
            <Flex align="center" justify="center" className="promote-center-content">
              <ProgresSpinner
                caption={intl.formatMessage({
                  id: 'promoteChanges.loadingVehicleData',
                })}
              />
            </Flex>
          ) : (
            <PromotedFilesPreview record={vehicle} detail={detail} />
          )}
        </Flex>
      </Flex>
    </Modal>
  )
}

export default PromotedFilesModal
